import React, { useRef, useState } from 'react';
import { Container, Form, Button, Card, Row, Col } from 'react-bootstrap';
import jsPDF from 'jspdf';
import axios from 'axios';

const StylishResume = () => {
  const [jobTitle, setJobTitle] = useState('');
  const [jobDescription, setJobDescription] = useState('');

  const handleJobTitleChange = (e) => {
    setJobTitle(e.target.value);
  };

  const fetchJobDescription = async () => {
    try {
      const response = await axios.post('http://192.168.0.14:5000/api/ai/generate-job-description-suggestions', { title: jobTitle });
      if (response.data.success) {
        setJobDescription(response.data.data);
      } else {
        alert('Failed to fetch job description.');
      }
    } catch (error) {
      console.error('Error fetching job description:', error);
      alert('An error occurred while fetching the job description.');
    }
  };
  const componentRef = useRef();

  const [cvData, setCvData] = useState({
    name: 'Shubham Mukati',
    title: 'Software Engineer',
    phoneNumber: '7247643764',
    email: 'shubham.mukati@parkhya.net',
    location: 'Indore, India',
    summary: 'Experienced software engineer with a passion for developing innovative applications.',
    experience: [
      {
        title: 'Software Developer',
        company: 'Parkhya Solution Pvt. Ltd.',
        startDate: '2024-12-16',
        endDate: 'till now',
        description: 'Worked on building scalable web applications using React and Node.js.',
      },
    ],
    education: [
      {
        degree: 'B.Tech (CSE)',
        institution: 'SAGE University, Indore',
        startDate: '2019',
        endDate: '2023',
      },
    ],
    projects: [
      {
        title: 'Balloon Decoration',
        description: 'A Website show the Event Management & Decoration ideas and images',
        technologies: ['HTML', 'CSS', 'JavaScript'],
        link: 'https://aaiji-decoration.com',
      },
    ],
    skills: ['JavaScript', 'React', 'Node.js'],
    extraFields: {
      github: 'https://github.com/shubhammukati',
      linkedin: 'https://linkedin.com/in/shubhammukati',
    },
  });

  const handleChange = (e, field) => {
    setCvData({ ...cvData, [field]: e.target.value });
  };

  const handleNestedChange = (e, field, index, subField) => {
    const updatedField = [...cvData[field]];
    updatedField[index] = { ...updatedField[index], [subField]: e.target.value };
    setCvData({ ...cvData, [field]: updatedField });
  };

  // const handleArrayChange = (e, field, index) => {
  //   const updatedField = [...cvData[field]];
  //   updatedField[index] = e.target.value;
  //   setCvData({ ...cvData, [field]: updatedField });
  // };

  const addEntry = (field) => {
    const newEntry =
      field === 'experience'
        ? { title: '', company: '', startDate: '', endDate: '', description: '' }
        : field === 'projects'
        ? { title: '', description: '', technologies: [], link: '' }
        : field === 'education'
        ? { degree: '', institution: '', startDate: '', endDate: '' }
        : '';
    setCvData({ ...cvData, [field]: [...cvData[field], newEntry] });
  };

  const removeEntry = (field, index) => {
    const updatedField = cvData[field].filter((_, i) => i !== index);
    setCvData({ ...cvData, [field]: updatedField });
  };

  const removeSkill = (index) => {
    const updatedSkills = cvData.skills.filter((_, i) => i !== index);
    setCvData({ ...cvData, skills: updatedSkills });
  };

  const handleSaveAsPDF = () => {
    const input = componentRef.current;
    const pdf = new jsPDF('p', 'mm', 'a4');

    pdf.html(input, {
      callback: function (pdf) {
        pdf.save('resume.pdf');
      },
      x: 10,
      y: 10,
      width: 190, // Adjust width to fit within A4 margins
      windowWidth: input.scrollWidth, // Ensures correct rendering of styles
    });
  };

  const handleSaveToDraft = async () => {
    try {
      const response = await axios.post(
        'https://ai-powered-cv-maker-api.vercel.app/api/draft/save-draft/67ab39cb0000f2df3bd0aa01',
        { cvData }
      );
      console.log('Draft saved successfully:', response.data);
      alert('Draft saved successfully!');
    } catch (error) {
      console.error('Error saving draft:', error);
      alert('Failed to save draft.');
    }
  };

  return (
    <Container className="mt-4">
      <Row>
        <Col md={6}>
          <Card>
            <Card.Body>
              <h4>Edit Resume</h4>
              <Form.Group className="mb-3">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  value={cvData.name}
                  onChange={(e) => handleChange(e, 'name')}
                />
              </Form.Group>
              <hr />
              <Form.Group className="mb-3">
                <Form.Label>Job Title</Form.Label>
                <Form.Control
                  type="text"
                  value={jobTitle}
                  onChange={handleJobTitleChange}
                  placeholder="Enter job title"
                />
              </Form.Group>
              <Button onClick={fetchJobDescription} className="mb-3">
                Generate Job Description
              </Button>
              {jobDescription && (
                <div className="mb-3">
                  <h5>Generated Job Description</h5>
                  <p>{jobDescription}</p>
                </div>
              )}
              <h5>Experience</h5>
              {cvData.experience.map((exp, index) => (
                <div key={index} className="mb-3">
                  <Form.Group>
                    <Form.Label>Title</Form.Label>
                    <Form.Control
                      type="text"
                      value={exp.title}
                      onChange={(e) => handleNestedChange(e, 'experience', index, 'title')}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Company</Form.Label>
                    <Form.Control
                      type="text"
                      value={exp.company}
                      onChange={(e) => handleNestedChange(e, 'experience', index, 'company')}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Start Date</Form.Label>
                    <Form.Control
                      type="text"
                      value={exp.startDate}
                      onChange={(e) => handleNestedChange(e, 'experience', index, 'startDate')}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>End Date</Form.Label>
                    <Form.Control
                      type="text"
                      value={exp.endDate}
                      onChange={(e) => handleNestedChange(e, 'experience', index, 'endDate')}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      type="text"
                      value={exp.description}
                      onChange={(e) => handleNestedChange(e, 'experience', index, 'description')}
                    />
                  </Form.Group>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => removeEntry('experience', index)}
                  >
                    Remove
                  </Button>
                  <hr />
                </div>
              ))}
              <Button onClick={() => addEntry('experience')} className="mb-3">
                Add Experience
              </Button>
              <hr />
              <h5>Education</h5>
              {cvData.education.map((edu, index) => (
                <div key={index} className="mb-3">
                  <Form.Group>
                    <Form.Label>Degree</Form.Label>
                    <Form.Control
                      type="text"
                      value={edu.degree}
                      onChange={(e) => handleNestedChange(e, 'education', index, 'degree')}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Institution</Form.Label>
                    <Form.Control
                      type="text"
                      value={edu.institution}
                      onChange={(e) => handleNestedChange(e, 'education', index, 'institution')}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Start Date</Form.Label>
                    <Form.Control
                      type="text"
                      value={edu.startDate}
                      onChange={(e) => handleNestedChange(e, 'education', index, 'startDate')}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>End Date</Form.Label>
                    <Form.Control
                      type="text"
                      value={edu.endDate}
                      onChange={(e) => handleNestedChange(e, 'education', index, 'endDate')}
                    />
                  </Form.Group>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => removeEntry('education', index)}
                  >
                    Remove
                  </Button>
                  <hr />
                </div>
              ))}
              <Button onClick={() => addEntry('education')} className="mb-3">
                Add Education
              </Button>
              <hr />
              <h5>Projects</h5>
              {cvData.projects.map((project, index) => (
                <div key={index} className="mb-3">
                  <Form.Group>
                    <Form.Label>Title</Form.Label>
                    <Form.Control
                      type="text"
                      value={project.title}
                      onChange={(e) => handleNestedChange(e, 'projects', index, 'title')}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      type="text"
                      value={project.description}
                      onChange={(e) => handleNestedChange(e, 'projects', index, 'description')}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Technologies</Form.Label>
                    <Form.Control
                      type="text"
                      value={project.technologies.join(', ')}
                      onChange={(e) => handleNestedChange(e, 'projects', index, 'technologies')}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Link</Form.Label>
                    <Form.Control
                      type="text"
                      value={project.link}
                      onChange={(e) => handleNestedChange(e, 'projects', index, 'link')}
                    />
                  </Form.Group>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => removeEntry('projects', index)}
                  >
                    Remove
                  </Button>
                  <hr />
                </div>
              ))}
              <Button onClick={() => addEntry('projects')} className="mb-3">
                Add Project
              </Button>
              <hr />
              <h5>Skills</h5>
              {cvData.skills.map((skill, index) => (
                <div key={index} className="d-flex justify-content-between align-items-center mb-2">
                  <span>{skill}</span>
                  <Button variant="danger" size="sm" onClick={() => removeSkill(index)}>
                    Remove
                  </Button>
                </div>
              ))}
              <Button onClick={() => setCvData({ ...cvData, skills: [...cvData.skills, ''] })}>
                Add Skill
              </Button>
              <hr />
              <Button onClick={handleSaveAsPDF} variant="secondary" className="mt-2 w-100">
                Save as PDF
              </Button>
              <Button onClick={handleSaveToDraft} variant="primary" className="mt-2 w-100">
                Save to Draft
              </Button>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <div
            ref={componentRef}
            className="p-4 border rounded"
            style={{
              backgroundColor: '#fff',
              fontFamily: 'Arial, sans-serif',
              width: '794px', // A4 width in pixels
              minHeight: '1123px', // A4 height in pixels
            }}
          >
            <div className="text-center mb-4" style={{ borderBottom: '2px solid #003366', paddingBottom: '10px' }}>
              <h1 style={{ color: '#003366', marginBottom: '5px' }}>{cvData.name}</h1>
              <h3 style={{ color: '#444', marginBottom: '10px' }}>{cvData.title}</h3>
              <p style={{ color: '#6c757d' }}>
                {cvData.phoneNumber} | {cvData.email} | {cvData.location}
              </p>
            </div>
            <div className="mb-4">
              <h4 style={{ color: '#003366', borderBottom: '1px solid #003366', paddingBottom: '5px' }}>SUMMARY</h4>
              <p style={{ color: '#343a40', lineHeight: '1.6' }}>{cvData.summary}</p>
            </div>
            <div className="mb-4">
              <h4 style={{ color: '#003366', borderBottom: '1px solid #003366', paddingBottom: '5px' }}>EXPERIENCE</h4>
              {cvData.experience.map((exp, index) => (
                <div key={index} className="mb-3">
                  <h5 style={{ color: '#444', marginBottom: '5px' }}>
                    {exp.title} - {exp.company}
                  </h5>
                  <p style={{ color: '#6c757d', marginBottom: '10px' }}>
                    {exp.startDate} - {exp.endDate}
                  </p>
                  <p style={{ color: '#343a40', lineHeight: '1.6' }}>{exp.description}</p>
                </div>
              ))}
            </div>
            <div className="mb-4">
              <h4 style={{ color: '#003366', borderBottom: '1px solid #003366', paddingBottom: '5px' }}>EDUCATION</h4>
              {cvData.education.map((edu, index) => (
                <div key={index} className="mb-3">
                  <h5 style={{ color: '#444', marginBottom: '5px' }}>{edu.degree}</h5>
                  <p style={{ color: '#6c757d' }}>
                    {edu.institution} | {edu.startDate} - {edu.endDate}
                  </p>
                </div>
              ))}
            </div>
            <div className="mb-4">
              <h4 style={{ color: '#003366', borderBottom: '1px solid #003366', paddingBottom: '5px' }}>PROJECTS</h4>
              {cvData.projects.map((project, index) => (
                <div key={index} className="mb-3">
                  <h5 style={{ color: '#444', marginBottom: '5px' }}>{project.title}</h5>
                  <p style={{ color: '#343a40', lineHeight: '1.6' }}>{project.description}</p>
                  <p style={{ color: '#343a40', lineHeight: '1.6' }}>
                    Technologies: {project.technologies.join(', ')}
                  </p>
                  <p style={{ color: '#343a40', lineHeight: '1.6' }}>
                    Link: <a href={project.link}>{project.link}</a>
                  </p>
                </div>
              ))}
            </div>
            <div className="mb-4">
              <h4 style={{ color: '#003366', borderBottom: '1px solid #003366', paddingBottom: '5px' }}>SKILLS</h4>
              <ul style={{ color: '#343a40', paddingLeft: '20px' }}>
                {cvData.skills.map((skill, index) => (
                  <li key={index}>{skill}</li>
                ))}
              </ul>
            </div>
            <div className="mb-4">
              <h4 style={{ color: '#003366', borderBottom: '1px solid #003366', paddingBottom: '5px' }}>EXTRA FIELDS</h4>
              <p style={{ color: '#343a40', lineHeight: '1.6' }}>
                GitHub: <a href={cvData.extraFields.github}>{cvData.extraFields.github}</a>
              </p>
              <p style={{ color: '#343a40', lineHeight: '1.6' }}>
                LinkedIn: <a href={cvData.extraFields.linkedin}>{cvData.extraFields.linkedin}</a>
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default StylishResume;
